import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

class Archive extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = 'Archief | Fietshelm';
  }

  render() {
    return (
      <React.Fragment>
        <Header title="Archief" />

        <main>
          <div className="container container--no-padding" id="inhoud">
            <div className="content">
              <h1>Sitearchief</h1>
              
              
              <p>Informatie van de overheid moet goed vindbaar zijn. Zowel informatie van nu als van vroeger.
Oude informatie kan belangrijk zijn voor onze geschiedenis of cultuur. Ook kunnen burgers en
bedrijven rechten ontlenen aan de informatie op een overheidswebsite. In een rechtszaak kan
informatie van een overheidswebsite bijvoorbeeld als bewijsmiddel worden gebruikt. Daarom
worden oude pagina&#39;s van deze website bewaard.</p>
<p>Dagelijks wordt er een kopie gemaakt. Wil je weten wat er eerder stond op deze website? Kijk dan op <a href="https://minienw.sitearchief.nl/?subsite=zetjefietshelmop#archive" target="_blank" rel="noopener noreferrer">minienw.sitearchief.nl</a></p>

 
            </div>
          </div>
        </main>

        <Footer />
      </React.Fragment>
    );
  }
}

export default Archive;

